import { addDays, format, subWeeks } from "date-fns";
import { isTheSameDate } from "../date";

const emptyWeek = start_date => ({
  start_date: format(start_date, "YYYY-MM-DD"),
  end_date: format(addDays(start_date, 6), "YYYY-MM-DD"),
  products: [],
  price: null,
});

/**
 * Given a sorted list where [0] element is the earliest available week,
 * creates a list of 1..n weeks in the past, filling out any missing weeks with dummy data.
 * @param {Array} weeklyData
 * @param {number} numberOfWeeks
 */
const getWeeksInChronologicalOrder = (weeklyData, numberOfWeeks) => {
  const lastWeek = new Date(weeklyData[0].start_date);
  return [...Array(numberOfWeeks).keys()].map(n => {
    const soughtWeek = subWeeks(lastWeek, n);
    const lastWeekData = weeklyData.find(week =>
      isTheSameDate(new Date(week.start_date), soughtWeek)
    );
    return lastWeekData || emptyWeek(soughtWeek);
  });
};

export default getWeeksInChronologicalOrder;
